import SalesTeam from "../../../classes/SalesTeam";
import { db } from "../../../boot/firebase";
import {
  collection,
  deleteDoc,
  doc,
  setDoc,
  updateDoc,
} from "firebase/firestore";

export const GET_SALES_TEAM = ({ dispatch }, id) => {
  return dispatch("GET_DOC", {
    converter: SalesTeam,
    path: SalesTeam.getPath(id),
    stateKey: "salesTeams",
    id,
  });
};

export const GET_SALES_TEAMS = ({ dispatch }, { where, limit, pagination }) => {
  return dispatch("GET_COLLECTION", {
    converter: SalesTeam,
    stateKey: "salesTeams",
    path: SalesTeam.getPath(),
    where,
    limit,
    pagination,
  });
};

export const LISTEN_SALES_TEAM = (
  { dispatch },
  { id, next, error, unlisten }
) => {
  return dispatch("LISTEN_DOC", {
    converter: SalesTeam,
    path: SalesTeam.getPath(id),
    stateKey: "salesTeams",
    id,
    next,
    error,
    unlisten,
  });
};

export const LISTEN_SALES_TEAMS = (
  { dispatch },
  { where, listenerPath, pagination, next, error, unlisten }
) => {
  return dispatch("LISTEN_COLLECTION", {
    converter: SalesTeam,
    path: SalesTeam.getPath(),
    stateKey: "salesTeams",
    where,
    listenerPath: listenerPath || "salesTeams",
    pagination,
    next,
    error,
    unlisten,
  });
};

export const SAVE_SALES_TEAM = async ({ state }, { id, data }) => {
  const now = new Date();
  const userID = state.user.id;
  const normalizedData = { ...data };

  if (Array.isArray(data.members)) {
    normalizedData.memberIDs = data.members
      .map((member) => member && member.userID)
      .filter(Boolean);
  }

  if (id) {
    // Update existing
    await updateDoc(doc(db, SalesTeam.getPath(id)), {
      ...normalizedData,
      modified: now,
      modifiedBy: userID,
    });
    return { id, ...normalizedData };
  } else {
    // Create new
    const docRef = doc(collection(db, SalesTeam.getPath()));
    await setDoc(docRef, {
      ...normalizedData,
      created: now,
      createdBy: userID,
      modified: null,
      modifiedBy: null,
    });
    return { id: docRef.id, ...normalizedData };
  }
};

export const DELETE_SALES_TEAM = async (context, id) => {
  await deleteDoc(doc(db, SalesTeam.getPath(id)));
  return id;
};
